import { useCallback } from 'react'
import { useInternalGraphql } from '../useInternalGraphql'

export function useGetUserSegmentation() {
  const { sendRequest } = useInternalGraphql({
    query: 'UserSegmentationQueryDocument',
    runOnInit: false,
  })

  return useCallback(async () => {
    let result = {
      segmentation: null,
      hasCompletedSegmentation: false,
    }
    try {
      const { data, errors: gqlErrors } = await sendRequest()
      if (gqlErrors && gqlErrors.length > 0) {
        throw gqlErrors
      }
      result = {
        segmentation: data?.me?.segmentation,
        hasCompletedSegmentation: data?.me?.hasCompletedSegmentation,
      }
    } catch (errs) {
      console.warn('[useGetUserSegmentation]', errs)
    }
    return result
  }, [sendRequest])
}
